const slides = [
  {
    name: "factshlogo.jpeg",
  },

  {
    name: "slider_img1.jpeg",
  },

  {
    name: "slider_img2.jpeg",
  },

  {
    name: "slider_img3.jpeg",
  },

  {
    name: "slider_img5.jpeg",
  },

  {
    name: "slider_img6.jpeg",
  },

  {
    name: "slider_img7.jpeg",
  },

  {
    name: "slider_img8.jpg",
  },
  
];
export default slides;
